// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"i3","message":"i4","close":"i5","closeMessage":"i6","closeIcon":"i7"};